import { render, staticRenderFns } from "./GruposLista.vue?vue&type=template&id=1996a8fc&"
import script from "./GruposLista.vue?vue&type=script&lang=js&"
export * from "./GruposLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports